import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import {TEXT_FIELD_STYLE} from "../../constants/Styles";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

export const StyledTextField = ({
  children,
  textFieldStyle = {},
  InputProps,
  ...props
}) => (
  <TextField
    fullWidth
    margin="dense"
    variant="outlined"
    InputProps={{
      style: { ...TEXT_FIELD_STYLE, ...textFieldStyle },
      ...InputProps
    }}
    {...props}
  >{children}</TextField>
)

export const StyledMultilineTextField = ({
  children,
  textFieldStyle = {},
  ...props
}) => (
 <TextField
    fullWidth
    margin="dense"
    variant="outlined"
    multiline
    rows={5}
    InputProps={{
      style: { ...TEXT_FIELD_STYLE, ...textFieldStyle }
    }}
    {...props}
  >{children}</TextField>
)

export const StyledRichTextEditor = ({
  value,
  onChange
}) => (
  <ReactQuill theme="snow" value={value} onChange={onChange} />
)

export const StyledAutocomplete = ({
  options,
  onChange,
  value,
  ...props
}) => (
  <Autocomplete
      disablePortal
      options={options}
      fullWidth
      value={value}
      onChange={onChange}
      renderInput={(params) => <StyledTextField {...props} {...params}/>}
    />
)
